import { Pipe, PipeTransform } from '@angular/core';
import { localizeString } from 'src/app/app.localize'

@Pipe({
  name: 'localize'
})
export class LocalizePipe implements PipeTransform {

  transform(value: number): string {
    return localizeString(value);
  }
}
